import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import { ContactsState, GlobalAction } from '.';
import { contactsReducer } from './contactsReducer';

type Props = {
  children: ReactNode;
};

type ContextProps = {
  state: ContactsState;
  dispatch: React.Dispatch<GlobalAction>;
};

const ContactsContext = createContext({} as ContextProps);

export const initialState: ContactsState = {
  groups: {
    selected: {
      groupId: '',
      name: '',
      loading: true,
      contacts: {
        items: [],
        count: 0,
        page: 0,
        size: parseInt(localStorage.getItem('contact_list') || '10'),
      },
    },
    items: [],
    count: 0,
    page: 0,
    size: parseInt(localStorage.getItem('group_list') || '10'),
    search: '',
    loading: true,
  },
  contacts: {
    items: [],
    count: 0,
    page: 0,
    size: parseInt(localStorage.getItem('contact_list') || '10'),
    search: '',
    loading: true,
  },
  optOuts: {
    items: [],
    count: 0,
    page: 0,
    size: parseInt(localStorage.getItem('contact_list') || '10'),
    search: '',
    loading: true,
  },
};

export const ContactsContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(contactsReducer, initialState);
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return (
    <ContactsContext.Provider value={value}>
      {children}
    </ContactsContext.Provider>
  );
};

export const useContactsContext = () => {
  const value = useContext(ContactsContext);
  return value;
};
